import { render, staticRenderFns } from "./SreApiUrlUpdateBox.vue?vue&type=template&id=ec0355e2"
import script from "./SreApiUrlUpdateBox.vue?vue&type=script&lang=js"
export * from "./SreApiUrlUpdateBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports